import Styled from 'styled-components'
import { minQuery } from '../../../../helpers'

export default Styled.div`
    div.adminForm--container {
        padding: 4em;
        height:600px;
        overflow: hidden;
        form {
            height:400px;
            padding:10px;
            overflow:scroll;
            overflow-x: hidden;
        }
        header {
            text-align: center;
            h2 {
                margin-bottom: 1em;
                font-weight: 500;
                font-size: 1.4rem;
            }
            p {
                font-size: 0.9rem;
                color: #fff;
            }
        }
        button {
            margin-top: 4em;
        }
    }
    div.input-row {
        ${minQuery('lg')} {
            grid-gap: 1.5em;
            display: grid;
            grid-template-columns: 1fr 1fr;
        }
    }
    span.span__checkbox {
        margin-left:10px;
        margin-bottom:12.5px;
    }
    div.adminForm--cities {
        margin-top:10px;
        margin-bottom:20px;
    }
    div.MultiSelect{
        color:#000;
        marign-left:-10px;
        background-color:"#3237AE";
    }
    div.CityBox{
        background:whitesmoke;
        display:flex;
        color:#000;
        margin-right:10px;
        cursor: pointer;
        padding-left:5px;
        padding-right:5px;
        max-width:200px;
        height:25px;
        margin-top:10px;
        overflow: hidden;
    }
`
